import { DevTool } from '@hookform/devtools'
import ClearAllIcon from '@mui/icons-material/ClearAll'
import FilterListIcon from '@mui/icons-material/FilterList';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import RestoreIcon from '@mui/icons-material/Restore'
import { Breadcrumbs, Button, Card, IconButton, Link, Menu, MenuItem, Paper, Stack, TextField, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import LoadingUI from '../../comman/LoadingUI'
import NoDataFound from '../../comman/NoDataFound'
import SnackBarUI from '../../comman/SnackBarUI'
import Appbar from '../../components/Appbar'
// import Drawer from '../../components/Drawer'
import { dateConvert } from '../../helper/dateConverter'
import Body from '../../layout/Body'
import { changeCatSeqAction } from '../../redux/toolkit/category/changeCategorySequence'

import { supportDataAction } from '../../redux/toolkit/support/list';
import { singleSupportDataAction } from '../../redux/toolkit/support/singleData';
import { useStyles } from '../../theme/theme'

import CreateSupport from './CreateSupport';
import UpdateSupport from './UpdateSupport';
import DeleteSupport from './DeleteSupport';
import RestoreSupport from './RestoreSupport';



const breadcrumb = (
    <Stack>
        <Breadcrumbs separator={<NavigateNextIcon sx={{ color: '#5E6C8A' }} fontSize="small" />} aria-label="breadcrumb">
            <Link underline="hover" sx={{ color: "#5E6C8A" }} href='/'>Home</Link>
            <Link underline="hover" sx={{ color: "#5E6C8A" }} href='/support'>Support Knowledge</Link>
        </Breadcrumbs>
        <Typography sx={{ color: "#5E6C8A" }} variant='h5'>Support Knowledge</Typography>
    </Stack>
)




export default function Index() {
    // state--->
    const { register, reset, control, handleSubmit } = useForm({});
    const permission = useSelector(state => state.getPermissionAndRole)
    const { data: permissionData } = permission
    const singleSupport = useSelector(state => state.singleSupport)
    const { data,loading,message,status } = singleSupport
    const {answers,title}=data

    const dispatch = useDispatch()
    const cat = useSelector(state => state.supportList)
    const { data: catData, loading: catDataLoading } = cat
    const catSeq = useSelector(state => state.changeCatSeq)
    const { status: catSeqStatus, message: catSeqMsg } = catSeq

    let can_delete = JSON.parse(localStorage.getItem("ss_active_usr"))?.settings?.can_delete
    let super_admin = permissionData?.role


    const [snack, setSnack] = useState(false)
    const [catMenu, setCatMenu] = useState(false)
    const [createCat, setCreateCat] = useState(false)
    const [updateCat, setUpdateCat] = useState(false)
    const [delCat, setDelCat] = useState(false)
    const [restoreCat, setRestoreCat] = useState(false)
    const [anchorCatMenu, setAnchorCatMenu] = useState()
    const [ativeFilter, setActiveFilter] = useState(false)
    const [pageSize, setPageSize] = useState(25);
    const [cat_id, seCat_id] = useState('')
    const classes = useStyles();
    const [date, setDate] = useState({
        start: null,
        end: null,
    })
    const [isFilterArea, setIsFilterArea] = useState(false)



    const catDataGridColumns = [
        {
            field: 's_no',
            headerName: 'S. No.',
            filterable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            renderCell: (index) => index?.api?.getRowIndex(index.row._id) + 1
        },
        {
            field: '_id',
            headerName: 'ID',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 200,
        },
        {
            field: 'title',
            headerName: 'Title',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 200,
        },
        {
            field: 'answers',
            headerName: 'Answers',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 200,
            renderCell: (params) => {
                return (  
                <ul>
              {params.row.answers.map(answer => (
                <li>
                  {answer}
                </li>
              ))}
            </ul>
        
                )
              },
        },
        // {
        //     field: 'sub_cat',
        //     headerName: 'Sub Category',
        //     headerClassName: 'super-app-theme--header',
        //     flex: 1,
        //     minWidth: 200,
        //     renderCell: (params) => {
        //         return (
        //             <>
        //                 <Typography>
        //                     {params?.row?.sub_cat?.length}
        //                 </Typography>
        //             </>
        //         )
        //     },
        // },
        // {
        //     field: 'link_qns',
        //     headerName: 'Total Questions',
        //     headerClassName: 'super-app-theme--header',
        //     flex: 1,
        //     minWidth: 200,
        //     renderCell: (params) => {
        //         return (
        //             <>
        //                 <Typography>
        //                     {params?.row?.link_qns?.length}
        //                 </Typography>
        //             </>
        //         )
        //     },
        // },
        // {
        //     field: 'no_of_survey',
        //     headerName: 'Number Of Survey',
        //     headerClassName: 'super-app-theme--header',
        //     flex: 1,
        //     minWidth: 200,
        // },
        // {
        //     field: 'sequence_number',
        //     headerName: 'Sequence of Category',
        //     renderCell: (params) => {
        //         return (
        //             <>
        //                 <TextField
        //                     sx={{ my: 2 }} type='number' label="Category Sequence" size='small'
        //                     defaultValue={params?.row?.sequence}
        //                     variant="outlined"
        //                     placeholder='Category Sequence'
        //                     {...register(params?.row?._id)}
        //                 />
        //             </>
        //         )
        //     },
        //     headerClassName: 'super-app-theme--header',
        //     flex: 1,
        //     minWidth: 200,
        //     hide: ativeFilter
        // },

        {
            field: 'edit', headerName: 'Edit Support',
            renderCell: (params) => {
                return (
                    <IconButton
                        onClick={() => {
                            dispatch(singleSupportDataAction(params?.row?._id))
                            setUpdateCat(true);
                        }}><EditIcon color='primary' />
                    </IconButton>
                )
            },
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 150,
            hide: ativeFilter
        },
        {
            field: 'delete', headerName: 'Delete Support', renderCell: () => {
                return (
                    <IconButton
                        onClick={(params) => {
                            setDelCat(true);
                            seCat_id(params?.row?._id)
                        }}
                        ><DeleteIcon color='error' />
                    </IconButton>
                )
            },
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 150,
            hide: ativeFilter

        },
        {
            field: 'revert',
            headerName: 'Revert Category',
            renderCell: () => {
                return (
                    <IconButton
                    onClick={(params) => {
                        setRestoreCat(true);
                        seCat_id(params?.row?._id)
                    }}
                    ><RestoreIcon color='success' />
                    </IconButton>
                )
            },
            headerClassName: 'super-app-theme--header',
            flex: 1,
            hide: !ativeFilter

        },
    ]


    // fn
    const handleCatChangeSeq = async (data) => {

        const changeCat = await dispatch(changeCatSeqAction(data))
        if (changeCat?.payload?.status) {
            await dispatch(supportDataAction({ is_deleted: false }))
            reset()
            setSnack(true)
        }

    }

    const handleclearFilter = () => {
        setActiveFilter(false)
        dispatch(supportDataAction({ is_deleted: false,page:0,limit:100 }))
    }

    const handleFilterData = () => {
        dispatch(supportDataAction({ is_deleted: false, page:0,limit:100 }))
    }

    // useEffect
    useEffect(() => {
        dispatch(supportDataAction({ is_deleted: false,page:0,limit:100 }))
    }, [dispatch])



    return (
        <>
            <Helmet><title>Survey Wall | Support Knowledge</title></Helmet>
            <Appbar breadcrumb={breadcrumb} />
            {/* <Drawer /> */}
            <Body>

                
                <Stack direction="row" justifyContent="space-between" alignItems="flex-end">
                    <Button variant="outlined" startIcon={<FilterListIcon />} onClick={() => { setIsFilterArea(!isFilterArea) }}>
                        filter by date
                    </Button>
                    <Button variant="contained" color="btn" startIcon={<AddIcon />} onClick={() => setCreateCat(true)}>
                        create support
                    </Button>
                </Stack>

                <Card sx={{ my: 2 }}>

                    {isFilterArea && <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Box sx={{ p: 2 }}>
                            <Typography color='#071D45'>Filter by Date</Typography>
                            <Stack direction={'row'} spacing={2} sx={{ mt: 1 }} alignItems='center'>
                                <DatePicker
                                    label="Start Date"
                                    value={date?.start}
                                    onChange={(value) => setDate({ ...date, start: value })}
                                    renderInput={(params) => <TextField {...params} />}
                                    maxDate={date?.end}

                                />
                                <DatePicker
                                    label="End Date"
                                    value={date?.end}
                                    onChange={(value) => setDate({ ...date, end: value })}
                                    renderInput={(params) => <TextField {...params} />}
                                    minDate={date?.start}
                                />
                                <Box>
                                    <IconButton onClick={handleFilterData} color='#071D45'><FilterAltIcon /></IconButton>
                                </Box>
                            </Stack>
                        </Box>
                    </LocalizationProvider>}


                    <Stack direction={'row'} justifyContent='space-between' alignItems='center' sx={{ ml: 1 }} >
                        <Typography sx={{ my: 1 }} variant='h6'>Support Question & Answer</Typography>
                        <Box sx={{ m: 2 }}>
                            {/* {(can_delete || super_admin == 'super_admin')
                                && */}
                            <>
                                <IconButton color='error' onClick={handleclearFilter}><ClearAllIcon /></IconButton>
                                
                                <Button  startIcon={<FilterListIcon />} onClick={(event) => {
                                        setCatMenu(true);
                                        setAnchorCatMenu(event.currentTarget);
                                    }}>
                                    filter
                                </Button>
                            </>


                            {/* // } */}

                            <Menu
                                open={catMenu}
                                onClose={() => setCatMenu(false)}
                                anchorEl={anchorCatMenu}
                            >
                                <MenuItem selected={ativeFilter}
                                    onClick={() => {
                                        setCatMenu(false)
                                        dispatch(supportDataAction({ is_deleted: true,page:0,limit:100 }))
                                        setActiveFilter(true)
                                    }} >Deleted</MenuItem>
                                <MenuItem selected={!ativeFilter}
                                    onClick={() => {
                                        setCatMenu(false)
                                        dispatch(supportDataAction({ is_deleted: false,page:0,limit:100 }))
                                        setActiveFilter(false)
                                    }}>Non Deleted</MenuItem>
                            </Menu>
                        </Box>
                    </Stack>

                    {/* table list */}
                    <Paper sx={{
                        bgcolor: '#fff',
                        '& .super-app-theme--header': {
                            bgcolor: '#E7F7FF',
                            color: '#000',
                        },
                    }} elevation={0}>


                        <DataGrid
                            className={classes.root}
                            sx={{
                                border: 0,
                                "& .MuiDataGrid-row:hover": {
                                    backgroundColor: "#E7F7FF"
                                    // color: "red"
                                  }
                            }}
                            getRowHeight={() => 'auto'}
                            autoHeight
                            rows={catData}
                            columns={catDataGridColumns}
                            getRowId={(row) => row._id}
                            disableSelectionOnClick
                            experimentalFeatures={{ newEditingApi: true }}
                            pagination
                            pageSize={pageSize}
                            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                            rowsPerPageOptions={[25, 50, 100]}
                            disableColumnSelector
                            loading={catDataLoading ? <LoadingUI /> : false}
                            onCellClick={(params) => {
                                seCat_id(params?.row?._id)
                            }}
                            components={{
                                NoRowsOverlay: () => <NoDataFound />,
                                Toolbar: GridToolbar,

                            }}

                        />
                    </Paper>
                </Card>

                {/* {!ativeFilter && catData?.length ? <Button onClick={handleSubmit(handleCatChangeSeq)} sx={{ my: 2 }} variant='contained' color='error'>Change Category Sequence</Button> : null} */}

                {/* crud */}
                <CreateSupport state={createCat} setState={setCreateCat} />
                <DeleteSupport cat_id={cat_id} state={delCat} setState={setDelCat} />
                {!loading?<UpdateSupport  state={updateCat} setState={setUpdateCat} />:<center>loading...</center>}
                <RestoreSupport cat_id={cat_id} state={restoreCat} setState={setRestoreCat}/>
            </Body >


            <SnackBarUI state={snack} setState={setSnack} status={catSeqStatus} message={catSeqMsg} />
            <DevTool control={control} />
        </>
    )
}
